import { AccesosComponent } from "./accesos/accesos.component"; 
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { adminGuard } from "src/app/guards/admin.guard";


const routes: Routes = [
      {
        path: '',
        children: [
          {
            path: 'accesos',
            component: AccesosComponent,
            data: {
              title: "Accesos",
              breadcrumb: "Accesos"
            },
            canActivate: [adminGuard]
          }
        ]
      }
]
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AccesosRoutingModule {}